import React from "react";

const presets = [
  { id: "today", label: "Today" },
  { id: "7d", label: "Last 7 Days" },
  { id: "30d", label: "Last 30 Days" },
  { id: "custom", label: "Custom" },
];

const ReportFilterBar = ({
  dateRange,
  onDateRangeChange,
  grouping,
  onGroupingChange,
}) => {
  const handlePresetClick = (preset) => {
    onDateRangeChange({ ...dateRange, preset });
  };

  const handleDateChange = (field, value) => {
    onDateRangeChange({ ...dateRange, preset: "custom", [field]: value });
  };

  return (
    <div className="report-filter">
      <div className="report-filter-left">
        <div className="report-filter-presets">
          {presets.map((p) => (
            <button
              key={p.id}
              type="button"
              onClick={() => handlePresetClick(p.id)}
              className={
                "report-filter-preset" +
                (dateRange.preset === p.id
                  ? " report-filter-preset--active"
                  : "")
              }
            >
              {p.label}
            </button>
          ))}
        </div>

        <div className="report-filter-dates">
          <label className="report-filter-date-field">
            <span>Start</span>
            <input
              type="date"
              value={dateRange.start || ""}
              onChange={(e) => handleDateChange("start", e.target.value)}
            />
          </label>
          <label className="report-filter-date-field">
            <span>End</span>
            <input
              type="date"
              value={dateRange.end || ""}
              onChange={(e) => handleDateChange("end", e.target.value)}
            />
          </label>
        </div>
      </div>

      {onGroupingChange && (
        <div className="report-filter-group">
          <span>Group by</span>
          <select
            value={grouping}
            onChange={(e) => onGroupingChange(e.target.value)}
          >
            <option value="day">Day</option>
            <option value="week">Week</option>
            <option value="month">Month</option>
          </select>
        </div>
      )}
    </div>
  );
};

export default ReportFilterBar;
